module.exports = __webpack_public_path__ + "media/img/frontend_application/map/philippines-ab0651847540afc607598cc1eba500e6.webp";